import NotFoundIcon from "@assets/icons/new/page-not-found_566px.svg";
import { ErrorPageBase } from "@pages/error-page-base";

/**
 * Page to show whenever the user access a page that we cannot match
 * to a valid page in the router.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <ErrorPageBase title="Page not found" iconImg={NotFoundIcon}>
      We couldn’t find the page you are looking for...
    </ErrorPageBase>
  );
}
